/* eslint-disable react-hooks/exhaustive-deps */
import { useParams } from 'react-router';
import { useAddTool } from '../../../../hooks/useAddTool';
import { useContext } from 'react';
import { AuthContext } from '../../../../../../providers/AuthProvider';
import { TPContext } from '../../../../providers/TPProvider';
import CONSTANTS from '../../../constants';

const {
  ENABLE_JIRAPLANNERBOT,
  ENABLE_ADOPLANNERBOT,
  ENABLE_SONARQUBEAGENT,
  ENABLE_DEVOPSAGENT,
} = CONSTANTS.TOOLS;

export const useAddProject = () => {
  const [addTool] = useAddTool();

  const { projectId: apmNumber } = useParams();
  const { profEmail } = useContext(AuthContext);
  const { apmInfo } = useContext(TPContext);

  const getEnvironmentFromURL = (): string => {
    const hostname = window.location.hostname;

    if (hostname.includes('dev.devx')) {
      return 'dev';
    } else if (hostname.includes('uat.devx')) {
      return 'uat';
    } else {
      return 'prod';
    }
  };

  const addProject = async (
    jiraProjectId: string,
    isEnabled: boolean,
    service: string,
    sonarqubeProjectKey?: string,
    org?: string,
    instanceName?: string,
  ) => {
    const commonFields = {
      'apm-number': apmNumber || '',
      'requestor-principal': profEmail,
      'env-prod': !/internal\.|dev\.|uat\./.test(window.location.href),
      'is-unprovision': !isEnabled,
    };

    const serviceSpecificConfig = {
      jira: {
        tool: ENABLE_JIRAPLANNERBOT,
        'instance-name': `${ENABLE_JIRAPLANNERBOT} ${apmInfo?.Name}`,
        'provision-key': apmNumber || '', // This field won't be in sonarqube
        'additional-data': {
          'instance-id': jiraProjectId,
          user_email: profEmail,
          is_enabled: isEnabled,
        },
      },
      ado: {
        tool: ENABLE_ADOPLANNERBOT,
        'instance-name': jiraProjectId,
        'provision-key': apmNumber || '', // This field won't be in sonarqube
        'additional-data': {
          'instance-id': jiraProjectId,
          user_email: profEmail,
          is_enabled: isEnabled,
        },
      },
      sonarqube: {
        tool: ENABLE_SONARQUBEAGENT,
        'instance-name': sonarqubeProjectKey,
        'additional-data': {
          'instance-id': sonarqubeProjectKey,
          env: getEnvironmentFromURL(),
          apm_number: apmNumber,
          action: isEnabled ? 'enable' : 'disable',
        },
      },
      devops: {
        tool: ENABLE_DEVOPSAGENT,
        'instance-name': instanceName || jiraProjectId,
        'additional-data': {
          'instance-id': jiraProjectId,
          env: getEnvironmentFromURL(),
          organization: org,
          apm_number: apmNumber,
          action: isEnabled ? 'enable' : 'disable',
        },
      },
    };

    const toolToAdd = {
      ...commonFields,
      ...serviceSpecificConfig[service as keyof typeof serviceSpecificConfig],
    };

    return addTool(
      toolToAdd,
      `${
        service === 'sonarqube'
          ? `Repo ${sonarqubeProjectKey}`
          : `Project ${instanceName || jiraProjectId}`
      } has been ${isEnabled ? 'enabled' : 'disabled'}`,
    );
  };

  return { addProject } as const;
};
